var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('banner-top',{staticClass:"mb-5 container-banner-top",attrs:{"small":"","data":_vm.getPromotionalDetailsBanner}}),_vm._v(" "),_c('div',_vm._l((_vm.productsPublicity),function(product){return _c('card-offer',{key:product.id,attrs:{"data":product}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b73a3266","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/product-publicity.vue
// module id = 1375
// module chunks = 0